'use strict';

module.exports = require('./invoke.js');



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/invoke/index.js
// module id = 4
// module chunks = 0